angular
  .module('configuration-management.module', [
    'ui.router'
  ]);

require('./car-configuration-view/car-configuration-view.component');
require('./car-view/car-view.component');